import React, { Component, Fragment } from "react";
import ButtonRuleRep from "../../Calcul Tools/ButtonRuleRep";
import InferenceForecaster from "../../Context/Components/InferenceForecaster";
import MiniPopup from "../../Modals and Popovers/MiniPopup";
import SandboxShowUserRequirements from "./SandboxShowUserRequirements";

// Logical symbols keyboard component as a class
class LogicKeyboard extends Component {
  render() {
    const {
      onCharacterSelect,
      onConfirm,
      onBackspace,
      currentContent,
      instructionText,
    } = this.props;

    const characterSets = [
      ["~", "∧", "∨", "⊻", "⊃", "⊅", "≡", "↑", "↓"],
      ["p", "q", "r", "s"],
      ["(", ")"],
    ];

    return (
      <div className="miniPopup-window-sandbox">
        {characterSets.map((set, index) => (
          <ul key={index}>
            {set.map((char) => (
              <li
                key={char}
                className="selectable"
                onClick={() => onCharacterSelect(char)}
              >
                {char}
              </li>
            ))}
          </ul>
        ))}
        <div className="future-premisseOrConclusion">
          {currentContent}
          <span className="blinking">_</span>
        </div>
        <div className="rule-modal-all-button-premisse">
          <button className="rule-modal-button" onClick={onBackspace}>
            <i className="fas fa-long-arrow-alt-left icon" />
          </button>
          <button className="rule-modal-button" onClick={onConfirm}>
            <i className="fas fa-check-square icon" />
          </button>
        </div>
        <p className="rule-modal-keyboard-premConc-instructionText">
          {instructionText}
        </p>
      </div>
    );
  }
}

// Possible premises list component as a class
class PossiblePremissesList extends Component {
  render() {
    const { possiblePremisses, currentPremisses, onPremisseSelect } =
      this.props;

    return (
      <li id="icon-possible-premisses">
        <i className="active fas fa-plus-circle icon" />
        <ul id="menu-possible-premisses">
          {possiblePremisses.map((premisse, index) => {
            const isAdded = currentPremisses.includes(premisse);
            return (
              <li
                key={index}
                className={`possible-premisse-sandbox ${
                  isAdded ? "possible-premisse-sandbox-added" : ""
                }`}
                onClick={() => onPremisseSelect(premisse)}
              >
                {premisse}
              </li>
            );
          })}
        </ul>
      </li>
    );
  }
}

// Main component using class approach
class ShowInfoSandbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      premisses: [],
      conclusion: "",
      conclusionReached: false,
      rulesImplied: [],
      possibleMeaning: [],
      keyboardMode: false, // false, "premisse", or "conclusion"
      currentInput: "",
    };
  }

  // Logic for managing character input
  addCharacter = (char) => {
    this.setState((prevState) => ({
      currentInput: prevState.currentInput + char,
    }));
  };

  removeLastCharacter = () => {
    this.setState((prevState) => ({
      currentInput: prevState.currentInput.slice(0, -1),
    }));
  };

  // Toggle keyboard visibility
  toggleKeyboard = (mode) => {
    this.setState((prevState) => ({
      keyboardMode: prevState.keyboardMode === mode ? false : mode,
      currentInput:
        prevState.keyboardMode === mode ? prevState.currentInput : "",
    }));
  };

  // Handle confirmation of input
  confirmInput = () => {
    const { currentInput, keyboardMode, premisses } = this.state;
    const inferenceContext = this.props.valueInference;

    if (currentInput.length === 0) return;

    if (keyboardMode === "premisse") {
      if (!premisses.includes(currentInput)) {
        const newPremisses = [...premisses, currentInput];

        // Update stored exercise
        const updatedExercise = {
          ...inferenceContext.storedObjectExercise,
          premisses: [
            ...inferenceContext.storedObjectExercise.premisses,
            currentInput,
          ],
        };

        this.setState({ premisses: newPremisses });
        inferenceContext.storeUserExerciseBeforeUpload(updatedExercise);
      }
    } else if (keyboardMode === "conclusion") {
      // Update stored exercise
      const updatedExercise = {
        ...inferenceContext.storedObjectExercise,
        conclusion: currentInput,
      };

      this.setState({ conclusion: currentInput });
      inferenceContext.storeUserExerciseBeforeUpload(updatedExercise);
    }

    this.setState({
      currentInput: "",
      keyboardMode: false,
    });
  };

  // Handle selecting a possible premisse
  handlePremisseSelect = (premisse) => {
    const { premisses } = this.state;
    const inferenceContext = this.props.valueInference;

    if (!premisses.includes(premisse)) {
      const newPremisses = [...premisses, premisse];

      // Update stored exercise
      const updatedExercise = {
        ...inferenceContext.storedObjectExercise,
        premisses: [
          ...inferenceContext.storedObjectExercise.premisses,
          premisse,
        ],
      };

      this.setState({ premisses: newPremisses });
      inferenceContext.storeUserExerciseBeforeUpload(updatedExercise);
    }
  };

  // Reset parts of state
  resetState = (part) => {
    const inferenceContext = this.props.valueInference;

    if (part === "premisse") {
      this.setState({ premisses: [] });
      inferenceContext.resetDeduction();
    } else if (part === "conclusion") {
      // Update stored exercise
      const updatedExercise = {
        ...inferenceContext.storedObjectExercise,
        conclusion: "",
      };

      this.setState({ conclusion: "" });
      inferenceContext.storeUserExerciseBeforeUpload(updatedExercise);
    }
  };

  // Handle inference addition
  addInference = (content, numberCommentary) => {
    const inferenceContext = this.props.valueInference;

    inferenceContext.setJournal(
      `Répétition de la prémisse ${content}`,
      "rule-journal"
    );
    inferenceContext.addInference({
      itself: content,
      numberCommentary: numberCommentary,
      commentary: "rep",
    });
  };

  // Handle inference forecast
  forecastInference = (content, numberCommentary) => {
    const inferenceContext = this.props.valueInference;
    InferenceForecaster([content], numberCommentary, "rep", inferenceContext);
  };

  // Render premisses as buttons
  renderPremisses = () => {
    const { premisses } = this.state;

    return premisses.map((premisse, index) => {
      // Calculate letter identifier (a-z)
      const letterCode = (9 + index + 1).toString(36).toLowerCase();

      return (
        <ButtonRuleRep
          key={index}
          className="premisse selectable"
          NumberButton={letterCode}
          NameButton={premisse}
          useOfAddInferenceSent={() => this.addInference(premisse, letterCode)}
          useOfForecastInferenceSent={() =>
            this.forecastInference(premisse, letterCode)
          }
          resetForecastInferenceSent={() => this.forecastInference("reset")}
        />
      );
    });
  };

  render() {
    const { exerciseSent, premissesSent } = this.props;
    const { premisses, conclusion, keyboardMode, currentInput } = this.state;

    // Skip rendering if not in sandbox mode
    if (exerciseSent.doable !== "sandbox") {
      return null;
    }

    // Filter out premisses that are already in the current set
    const filteredPossiblePremisses = premissesSent.filter(
      (p) => !premisses.includes(p)
    );

    return (
      <Fragment>
        <div className="deducer-content-panel" id="sandbox-header">
          <div className="sandbox-premisses-container">
            <ul style={{ display: "flex", flexDirection: "row" }}>
              {/* Premisses section */}
              <span>Prémisses</span>

              {/* Possible premisses dropdown */}
              <PossiblePremissesList
                possiblePremisses={filteredPossiblePremisses}
                currentPremisses={premisses}
                onPremisseSelect={this.handlePremisseSelect}
              />
              <MiniPopup
                iconClass="far fa-keyboard icon miniPopup-button"
                onClick={() => this.toggleKeyboard("premisse")}
                title="Cliquez ici pour afficher/cacher le clavier permettant de créer une prémisse."
              />
              <MiniPopup
                iconClass="fas fa-eraser icon"
                onClick={() => this.resetState("premisse")}
                title="Effacer toutes les prémisses."
              />
            </ul>

            {/* Premisses list */}
            <div className="sandbox-premissesList-itself">
              {this.renderPremisses()}
            </div>
          </div>
          <div className="sandbox-conclusion-container">
            {/* Conclusion section */}
            Conclusion
            <ul style={{ display: "flex", flexDirection: "row" }}>
              <MiniPopup
                iconClass="far fa-keyboard icon miniPopup-button"
                onClick={() => this.toggleKeyboard("conclusion")}
                title="Cliquez ici pour afficher/cacher le clavier permettant de créer une conclusion."
              />
              <MiniPopup
                iconClass="fas fa-eraser icon"
                onClick={() => this.resetState("conclusion")}
                title="Effacer la conclusion."
              />
            </ul>
            <div className="sandbox-conclusion-itself">{conclusion}</div>
          </div>
        </div>

        {/* Keyboard overlay - only shown when keyboardMode is active */}
        {keyboardMode && (
          <LogicKeyboard
            onCharacterSelect={this.addCharacter}
            onConfirm={this.confirmInput}
            onBackspace={this.removeLastCharacter}
            currentContent={currentInput}
            instructionText={
              keyboardMode === "premisse"
                ? "Ajoutez une prémisse."
                : "Entrez la conclusion."
            }
          />
        )}
        <SandboxShowUserRequirements sandboxDataSent={this.state} />
      </Fragment>
    );
  }
}

export default ShowInfoSandbox;



// WEBPACK FOOTER //
// ./src/components/Pages/Components/ShowInfoSandbox.js